export default __webpack_public_path__ + "static/media/88.89d92de0.png";